import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { getExportTaskStatusFailed, getExportTaskStatusSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL_V2 } from '../../../configs';

export default function* getExportTaskStatus(action) {
  try {
    const url = `${BACKEND_URL_V2}/export-tasks/${action.payload}`;
    const response = yield makeRequest(url, {}, action, 'GET', true);
    const data = yield getBodyJson(response);
    if (response.status === OK && data.data) {
      yield put(getExportTaskStatusSuccessful());
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(getExportTaskStatusFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(getExportTaskStatusFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
